import { action, observable } from 'mobx';
import { CalendarEventEditForm, } from 'application/schedule/forms';
import { BaseEditViewStore } from 'core/stores';
import { ScheduleService } from 'application/schedule/services';
import { PickTicketHeaderService } from "application/pick-ticket/services";
import { FacilityOrderService } from "application/facility-order/services";
import { LookupService } from "common/services";

class OrderingTaskEditViewStore extends BaseEditViewStore {
    @observable accessor task = null;
    @observable accessor deliveryDate = null;

    constructor(rootStore, componentParams) {
        const service = new ScheduleService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'ordering-task-edit',
            autoInit: true,
            id: componentParams.modalParams.data.item.id,
            Form: CalendarEventEditForm,
            actions: () => {
                return {
                    get: async () => {
                        const item = componentParams.modalParams.data.item;
                        const parentFacilityScheduleDateId = item.parentFacilityScheduleDateId;

                        if (parentFacilityScheduleDateId) {
                            const response = await service.get(parentFacilityScheduleDateId, { embed: 'FacilityOrder,Facility' });
                            item.orderingDate = response.data.date;
                            item.orderingDateOfService = response.data.dateOfService;
                            item.facilityOrder = response.data.facilityOrder;
                            item.facility = response.data.facility;
                        }

                        await this.getLookups();
                        await this.getPickTicketStatus(item.facilityOrder && item.facilityOrder.pickTicketHeaderId);

                        return {...item, isWoundCare: item.areaOfCareName ==='Wound Care' };
                    },
                    update: async (resource) => {
                        const response = await service.update({ ...this.task, ...resource });
                        this.task = { ...this.task, ...resource };
                        return response.data;
                    }
                }
            },
            FormClass: CalendarEventEditForm,
        });

        this.modalParams = componentParams.modalParams;

        this.task = componentParams.modalParams.data.item;
        this.userRoles = this.rootStore.userStore.applicationUser.roles;

        this.service = new ScheduleService(rootStore.application.baasic.apiClient);
        this.lookupService = new LookupService(rootStore.application.baasic.apiClient);
        this.pickTicketHeaderService = new PickTicketHeaderService(rootStore.application.baasic.apiClient);
    }

    @action
    setItem(item) {
        this.item = item;
        this.orderingDate = item.orderingDate;
        this.dateOfService = item.orderingDateOfService;
        this.deliveryDate = item.date;
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.update({
                id: this.id,
                ...resource
            });

            this.form.setFieldsDisabled(false);

            this.modalParams.close();
            if (this.modalParams.data.onSuccess) {
                this.modalParams.data.onSuccess();
            }

            await setTimeout(() => this.rootStore.notificationStore.success("Task successfully updated."));
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }

    @action.bound
    async getLookups() {
        const result = await this.lookupService.getLookups('PickTicketHeaderStatus');
        this.pickTicketHeaderStatus = result.pickTicketHeaderStatus;
    }
 
    @action.bound
    async getPickTicketStatus(pickTicketHeaderId) {
        this.pickTicketHeaderStatusId == null;
        if(pickTicketHeaderId){
            const result = await this.pickTicketHeaderService.get(pickTicketHeaderId);
            this.pickTicketHeaderStatusId = result.data.pickTicketHeaderStatusId;
        }
    }

    @action.bound
    async openPickTicket(facilityOrder, pickTicketHeaderId) {
        localStorage.setItem('refreshPickTicket', true);
        localStorage.setItem(`updatePickTicketStatus${pickTicketHeaderId}`, true);
        let route = facilityOrder.isNewFlow2 ? 'master.app.main.facility-order.pick-ticket-new-flow.list' : 'master.app.main.facility-order.pick-ticket.list';

        window.open(`${this.rootStore.routerStore
            .findRoute(route)
            .pattern.replace(":facilityOrderId", facilityOrder.id).replace(":pickTicketHeaderId", pickTicketHeaderId)}`);
    }

    @action.bound
    async openNikoFacilityOrder(facilityOrderId) {
        const facilityOrderService = new FacilityOrderService(this.rootStore.application.baasic.apiClient);
        const targetPage = (await facilityOrderService.getNikoTargetPage(facilityOrderId)).data;
        return window.open(`${this.rootStore.routerStore.findRoute('master.app.main.niko-facility-order.' + targetPage + '-preview').pattern.replace(':id', facilityOrderId)}`, '_blank');
    }

    @action.bound
    async downloadNikoPickTicketExcel(facilityOrderId) {
        const result = await this.pickTicketHeaderService.hasPickTicketItemsNiko(facilityOrderId, 'Pick Ticket');
        if (!result.hasItems) {
            this.rootStore.notificationStore.error("There are no items to include on the Pick Ticket.");
            return;
        }
        const url = `${this.pickTicketHeaderService.pickTicketReportDownloadUrlNiko(facilityOrderId)}?format=XLSX&contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl}&ttype=${this.rootStore.authStore.token.type}`;
        window.open(url);
    }
}
export default OrderingTaskEditViewStore;
